{
  "name": "31-Divided Fifth (ratios repeating at the 3/2)",
  "description": "13-tone 7-Limit Rational Intonation scale, consisting of 13 notes per 3/2 derived from harmonic partial row intervals up to a prime limit of 7. The pattern chosen takes all complete and gapless harmonic and subharmonic divisions of the perfect fifth and perfect fourth within the 23 limit and compiles notes which occur in at least two such divisions. The division of the fifth and two symmetrically placed divisions of the fourth are superposed. The central 1/1 ratio is tuned to Pythagorean D (293.333333 Hz), so that the next cycle begins at A 440 Hz.",
  "scale": [
    "16/15",
    "15/14",
    "9/8",
    "8/7",
    "7/6",
    "6/5",
    "5/4",
    "9/7",
    "21/16",
    "4/3",
    "7/5",
    "45/32",
    "3/2"
  ],
  "key_colors_mode": "manual",
  "short_description": "13-JI-7L-P5",
  "built_in_group": "Rational Intonation (JI)",
  "key_labels": "note_names",
  "note_names": [
    "1/1",
    "16/15",
    "15/14",
    "9/8",
    "8/7",
    "7/6",
    "6/5",
    "5/4",
    "9/7",
    "21/16",
    "4/3",
    "7/5",
    "45/32",
    "3/2"
  ],
  "note_colors": [
    "#ff9a9a",
    "#dee2da",
    "#e7e7ca",
    "#ffffff",
    "#e2caca",
    "#ffe5e5",
    "#dee2da",
    "#fffae5",
    "#e2caca",
    "#ffe5e5",
    "#ffffff",
    "#ece6df",
    "#fffae5",
    "ffffff"
  ],
  "equivSteps": 13,
  "fundamental": 293.3333333,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
